module.exports = __webpack_public_path__ + "static/img/aepic-12.3c8b276.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-12.jpg
// module id = SEwH
// module chunks = 51